var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "E86415C2-435D-4435-B027-F6B56B09BB64")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.300000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "customers---replace-customer",
    transform: "translate(-427.000000, -577.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(224.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(40.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customers",
    transform: "translate(163.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    opacity: 0.200000003,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,18 C19.7614237,18 22,20.2385763 22,23 L22,27 C22,27.5522847 21.5522847,28 21,28 L1,28 C0.44771525,28 6.76353751e-17,27.5522847 0,27 L0,23 C-3.38176876e-16,20.2385763 2.23857625,18 5,18 L17,18 Z M28,19 C30.209139,19 32,20.790861 32,23 L32,26.2 C32,26.6418278 31.6418278,27 31.2,27 L24,27 L24,22 C24,20.9071548 23.7078258,19.8825506 23.1973296,19.0000394 L28,19 Z M24,7 C26.7614237,7 29,9.23857625 29,12 C29,14.7614237 26.7614237,17 24,17 C21.2385763,17 19,14.7614237 19,12 C19,9.23857625 21.2385763,7 24,7 Z M11,4 C14.3137085,4 17,6.6862915 17,10 C17,13.3137085 14.3137085,16 11,16 C7.6862915,16 5,13.3137085 5,10 C5,6.6862915 7.6862915,4 11,4 Z",
    id: "Combined-Shape",
    fill: "#204569"
  }))))))))));
};

export default __webpack_public_path__ + "static/media/customer_ico.6f9dba25.svg";
export { SvgComponent as ReactComponent };